//COMPANIES
export const CREATE_COMPANY = 'CREATE_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const STORE_COMPANIES = 'STORE_COMPANIES';
export const LIST_COMPANIES = 'LIST_COMPANIES';
export const LIST_AVAILABLE_COMPANIES = 'LIST_AVAILABLE_COMPANIES';
export const STORE_AVAILABLE_COMPANIES = 'STORE_AVAILABLE_COMPANIES';
export const SET_AVAILABLE_COMPANIES_STATUS = 'SET_AVAILABLE_COMPANIES_STATUS';
export const LIST_ACTIVE_LICENSES = 'LIST_ACTIVE_LICENSES';
export const STORE_ACTIVE_LICENSES = 'STORE_ACTIVE_LICENSES';
export const LIST_MASTER_ADMINS_LOCATION = 'LIST_MASTER_ADMINS_LOCATION';
export const STORE_MASTER_ADMINS_LOCATION = 'STORE_MASTER_ADMINS_LOCATION';

export const ACTIVATE_LICENSE = 'ACTIVATE_LICENSE';
export const GENERATE_LICENSE = 'GENERATE_LICENSE';
export const STORE_LICENSE = 'STORE_LICENSE';
export const GET_LICENSE = 'GET_LICENSE';
export const RENEW_LICENSE = 'RENEW_LICENSE';
export const REVOKE_LICENSE = 'REVOKE_LICENSE';
export const YEARLY_PROJECTIONS = 'YEARLY_PROJECTIONS';
export const ACTUAL_PROJECTIONS = 'ACTUAL_PROJECTIONS';
export const STORE_YEARLY_PROJECTIONS = 'STORE_YEARLY_PROJECTIONS';
export const STORE_ACTUAL_PROJECTIONS = 'STORE_ACTUAL_PROJECTIONS';
export const UPDATE_LICENSE_AMOUNT = 'UPDATE_LICENSE_AMOUNT';
export const GET_COMPANY_MEMBERSHIPS = 'GET_COMPANY_MEMBERSHIPS';
export const STORE_COMPANY_MEMBERSHIPS = 'STORE_COMPANY_MEMBERSHIPS';
export const LIST_LICENSE_PAYMENTS = 'LIST_LICENSE_PAYMENTS';
export const STORE_LICENSE_PAYMENTS = 'STORE_LICENSE_PAYMENTS';
export const UPDATE_LICENSE_PAYMENT = 'UPDATE_LICENSE_PAYMENT';
export const RECORD_NEXT_CYCLE_PAYMENT = 'RECORD_NEXT_CYCLE_PAYMENT';
export const MARK_CYCLE_PAID = 'MARK_CYCLE_PAID';

//MACHINE
export const EDIT_MACHINE = 'EDIT_MACHINE';
export const LIST_MACHINE = 'LIST_MACHINE';
export const LIST_READING = 'LIST_READING';
export const STORE_MACHINE = 'STORE_MACHINE';
export const LIST_SESSION_IDS = 'LIST_SESSION_IDS';
export const STORE_ALL_SESSION_IDS = 'STORE_ALL_SESSION_IDS';
export const CLEAR_READING = 'CLEAR_READING';

//GAME
export const EDIT_GAME = 'EDIT_GAME';
export const LIST_GAME = 'LIST_GAME';
export const STORE_GAME = 'STORE_GAME';

//Transaction Category
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const LIST_CATEGORY = 'LIST_CATEGORY';
export const STORE_CATEGORY = 'STORE_CATEGORY';

//MACHINE ASSIGN
export const EDIT_ASSIGN_MACHINE = 'EDIT_ASSIGN_MACHINE';
export const LIST_ASSIGN_MACHINE = 'LIST_ASSIGN_MACHINE';
export const STORE_ASSIGN_MACHINE = 'STORE_ASSIGN_MACHINE';
export const RESET_ASSIGN_MACHINE = 'RESET_ASSIGN_MACHINE';

export const UPDATE_READING = 'UPDATE_READING';
export const STORE_READING = 'STORE_READING';
export const AVAILABLE_EMPLOYEE_SESSIONS = 'AVAILABLE_EMPLOYEE_SESSIONS';
export const STORE_AVAILABLE_EMPLOYEE_SESSIONS =
  'STORE_AVAILABLE_EMPLOYEE_SESSIONS';
export const STORE_ALL_READING = 'STORE_ALL_READING';
export const END_SESSION = 'END_SESSION';
export const START_SESSION = 'START_SESSION';
export const CANCEL_SESSION = 'CANCEL_SESSION';
export const LOAD_STARTED_SESSION = 'LOAD_STARTED_SESSION';
export const STORE_STARTED_SESSION = 'STORE_STARTED_SESSION';
export const LIST_MATCH_TICKETS = 'LIST_MATCH_TICKETS';
export const STORE_ALL_MATCH_TICKETS = 'STORE_ALL_MATCH_TICKETS';
export const GET_PREV_IN_OUT = 'GET_PREV_IN_OUT';
export const OPEN_SESSION_READING = 'OPEN_SESSION_READING';
export const GET_LAST_SESSION_READING = 'GET_LAST_SESSION_READING';
export const LIST_DELETED_READING_SESSIONS = 'LIST_DELETED_READING_SESSIONS';
export const RESTORE_READING_SESSION = 'RESTORE_READING_SESSION';
export const DELETE_FOREVER_READING_SESSION = 'DELETE_FOREVER_READING_SESSION';

//Clock
export const CLOCK_IN = 'CLOCK_IN';
export const CLOCK_OUT = 'CLOCK_OUT';
export const STORE_CLOCK = 'STORE_CLOCK';
export const LOAD_CLOCK_RECORD = 'LOAD_CLOCK_RECORD';

//Employee Session
export const LIST_EMPLOYEE_SESSION = 'LIST_EMPLOYEE_SESSION';
export const STORE_ALL_EMPLOYEE_SESSION = 'STORE_ALL_EMPLOYEE_SESSION';
export const UPDATE_EMPLOYEE_STATUS = 'UPDATE_EMPLOYEE_STATUS';
export const STORE_UPDATED_EMPLOYEE_SESSION = 'STORE_UPDATED_EMPLOYEE_SESSION';
export const MANUAL_CLOCK_IN = 'MANUAL_CLOCK_IN';
export const DELETE_EMPLOYEE_SESSION = 'DELETE_EMPLOYEE_SESSION';
export const FORCE_CLOCK_OUT = 'FORCE_CLOCK_OUT';
//Points watching
export const GET_POINT_WATCHING = 'GET_POINT_WATCHING';
export const STORE_POINT_WATCHING = 'STORE_POINT_WATCHING';
// Points Watching (spec v1.0) — By session / By employee / Alerts
export const GET_POINT_WATCHING_BY_DATE = 'GET_POINT_WATCHING_BY_DATE';
export const STORE_POINT_WATCHING_BY_DATE = 'STORE_POINT_WATCHING_BY_DATE';
export const GET_POINT_WATCHING_EMPLOYEE_DAYS =
  'GET_POINT_WATCHING_EMPLOYEE_DAYS';
export const STORE_POINT_WATCHING_EMPLOYEE_DAYS =
  'STORE_POINT_WATCHING_EMPLOYEE_DAYS';
export const GET_POINT_WATCHING_DAY_ENTRIES = 'GET_POINT_WATCHING_DAY_ENTRIES';
export const STORE_POINT_WATCHING_DAY_ENTRIES =
  'STORE_POINT_WATCHING_DAY_ENTRIES';
export const GET_POINT_WATCHING_ALERTS = 'GET_POINT_WATCHING_ALERTS';
export const STORE_POINT_WATCHING_ALERTS = 'STORE_POINT_WATCHING_ALERTS';
export const CLEAR_POINT_WATCHING_ALERT = 'CLEAR_POINT_WATCHING_ALERT';

//Match Report
export const MATCH_POINT_PDF_PREVIEW = 'MATCH_POINT_PDF_PREVIEW';
export const MATCH_POINT_STORE_PDF_PREVIEW_READY =
  'MATCH_POINT_STORE_PDF_PREVIEW_READY';
export const MATCH_POINT_RESET_PDF_PREVIEW_DATA =
  'MATCH_POINT_RESET_PDF_PREVIEW_DATA';

//MASTER READING REPORT
export const MASTER_READING_PDF_PREVIEW = 'MASTER_READING_PDF_PREVIEW';
export const MASTER_READING_STORE_PDF_PREVIEW_READY =
  'MASTER_READING_STORE_PDF_PREVIEW_READY';
export const MASTER_READING_RESET_PDF_PREVIEW_DATA =
  'MASTER_READING_RESET_PDF_PREVIEW_DATA';

//machine picture
export const ADD_MACHINE_PICTURE = 'ADD_MACHINE_PICTURE';
export const LIST_MACHINE_PICTURE = 'LIST_MACHINE_PICTURE';
export const STORE_MACHINE_PICTURE = 'STORE_MACHINE_PICTURE';
export const DELETE_MACHINE_PICTURE = 'DELETE_MACHINE_PICTURE';

//
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';

export const STORE_RESPONSE_MESSAGE = 'STORE_RESPONSE_MESSAGE';

//NOTE
export const ADD_NOTE = 'ADD_NOTE';
export const LIST_NOTES = 'LIST_NOTES';
export const STORE_NOTES = 'STORE_NOTES';
export const DELETE_NOTE = 'DELETE_NOTE';

//Weekly Report

export const LIST_REPORT = 'LIST_REPORT';
export const STORE_REPORT = 'STORE_REPORT';
export const UPDATE_REPORT_FIELD = 'UPDATE_REPORT_FIELD';
export const CLEAR_WEEKLY_REPORT = 'CLEAR_WEEKLY_REPORT';
export const UPDATE_MANAGER_BANK = 'UPDATE_MANAGER_BANK';
export const EDIT_BANK_BOARD_ENTRY = 'EDIT_BANK_BOARD_ENTRY';
export const DELETE_BANK_BOARD_ENTRY = 'DELETE_BANK_BOARD_ENTRY';

export const STORE_MANAGER_SETTING = 'STORE_MANAGER_SETTING';
export const GET_MANAGER_SETTING = 'GET_MANAGER_SETTING';
export const SAVE_MANAGER_SETTING = 'SAVE_MANAGER_SETTING';
export const SAVE_MANAGER_SUMMARY = 'SAVE_MANAGER_SUMMARY';

export const LIST_SHORT_ANALYSIS = 'LIST_SHORT_ANALYSIS';
export const STORE_SHORT_ANALYSIS = 'STORE_SHORT_ANALYSIS';

//Maintenance Permit
export const GRANT_MAINTENANCE_PERMIT = 'GRANT_MAINTENANCE_PERMIT';
export const REVOKE_MAINTENANCE_PERMIT = 'REVOKE_MAINTENANCE_PERMIT';
export const LOAD_MAINTENANCE_PERMIT = 'LOAD_MAINTENANCE_PERMIT';
export const STORE_MAINTENANCE_PERMIT = 'STORE_MAINTENANCE_PERMIT';
export const STORE_MAINTENANCE_PERMIT_HISTORY =
  'STORE_MAINTENANCE_PERMIT_HISTORY';
